import React, { useEffect, useState } from 'react';
import { Modal, Button, Input, Form, Select } from 'antd';
import { toast } from 'react-toastify';
import { editOffer, getAllTypeOffers } from '../../../../../services/offers/offersApi'; // Ensure this API function is defined

const { Option } = Select;

const EditOffre = ({ isOpen, onClose, onSubmit, offer }) => {
    const [titre, setTitre] = useState('');
    const [description, setDescription] = useState('');
    const [montant, setMontant] = useState('');
    const [coins, setCoins] = useState('');
    const [promotion, setPromotion] = useState('');
    const [adminId, setAdminId] = useState('');
    const [typeId, setTypeId] = useState('');
    const [etat, setEtat] = useState('disponible');
    const [errors, setErrors] = useState({});
    const [typeOffers, setTypeOffers] = useState([]);

    const clearState = () => {
        setTitre('');
        setDescription('');
        setMontant('');
        setCoins('');
        setPromotion('');
        setAdminId('');
        setTypeId('');
        setEtat('disponible');
        setErrors({});
    };

    useEffect(() => {
        if (isOpen) {
            clearState(); // Reset state when modal is opened
            fetchTypeOffers(); // Fetch type offers when modal opens
            if (offer) {
                // Populate fields with existing offer data
                setTitre(offer.titre);
                setDescription(offer.description);
                setMontant(offer.montant);
                setCoins(offer.coins/1000);
                setPromotion(offer.promotion);
                setAdminId(offer.admin_id);
                setTypeId(offer.type_id);
                setEtat(offer.etat);
            }
        }
    }, [isOpen, offer]);

    const fetchTypeOffers = async () => {
        try {
            const response = await getAllTypeOffers();
            setTypeOffers(response.data); // Assuming response.data contains the array of type offers
        } catch (error) {
            toast.error('Failed to fetch type offers'); // Notify error
        }
    };

    const handleSubmit = () => {
        const data = {  montant, coins:String(coins*1000), promotion, admin_id: adminId, type_id: typeId, etat }; // Prepare data for submission

        editOffer(offer.id, data) // Assuming editOffer takes the offer ID and the data
            .then((response) => {
                toast.success('Offer updated successfully!');
                onSubmit();
                onClose();
                clearState();
            })
            .catch((error) => {
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrors(error.response.data.errors);
                }
            });
    };

    return (
        <Modal
            title="Editer Offre"
            visible={isOpen}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Fermer
                </Button>,
                <Button key="submit" type="primary" onClick={handleSubmit}>
                    Mettre à jour
                </Button>,
            ]}
        >
            <Form layout="vertical">
                
                <Form.Item
                    label="Montant"
                    validateStatus={errors.montant ? 'error' : ''}
                    help={errors.montant ? errors.montant[0] : ''}
                >
                    <Input
                        value={montant}
                        onChange={(e) => setMontant(e.target.value)}
                        placeholder="Montant de l'offre"
                        required
                    />
                </Form.Item>
                <Form.Item
                    label="Coins"
                    validateStatus={errors.coins ? 'error' : ''}
                    help={errors.coins ? errors.coins[0] : ''}
                >
                   <div className="input-group">
                    <input
                        type="number"
                        className="form-control mb-4"
                        value={coins}
                        onChange={(e) => setCoins(e.target.value)}
                            
                        style={{ backgroundColor: 'var(--input-bg) !important' }}
                    />
                    <div className="input-group-append">
                        <span className="input-group-text" style={{ backgroundColor: 'var(--input-bg) !important' }}>K</span>
                    </div>
                </div>
                </Form.Item>
                <Form.Item
                    label="Promotion"
                >
                    <Input
                        value={promotion}
                        onChange={(e) => setPromotion(e.target.value)}
                        placeholder="Promotion (optional)"
                    />
                </Form.Item>
                
                <Form.Item
                    label="Type"
                    validateStatus={errors.type_id ? 'error' : ''}
                    help={errors.type_id ? errors.type_id[0] : ''}
                >
                    <Select
                        value={parseInt(typeId)}
                        onChange={(value) => setTypeId(value)}
                        placeholder="Select Type"
                        required
                    >
                        {typeOffers.map((offer) => (
                            <Option key={offer.id} value={offer.id}>
                                {offer.nom} 
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    label="État"
                    validateStatus={errors.etat ? 'error' : ''}
                    help={errors.etat ? errors.etat[0] : ''}
                >
                    <Select
                        value={etat}
                        onChange={(value) => setEtat(value)}
                        placeholder="Select État"
                        required
                    >
                        <Option value="disponible">Disponible</Option>
                        <Option value="nondiponible">Non Disponible</Option>
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default EditOffre; 